import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { LanguageSwitcher } from '../common/LanguageSwitcher';

/** Top bar. Shows Dashboard / Sign Out once someone is signed in, Sign In / Sign Up otherwise. */
export function SiteHeader() {
  const { t } = useTranslation();
  const { currentUser, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/">
          <img src="/logo-transparent.svg" alt={t('nav.logoAlt')} className="logo" />
        </Link>
        <nav className="header-nav">
          <LanguageSwitcher />
          {currentUser ? (
            <>
              <Link to="/dashboard" className="signin-nav-link">{t('nav.dashboard')}</Link>
              <button type="button" onClick={handleSignOut} className="signup-link header-signout">
                {t('nav.signOut')}
              </button>
            </>
          ) : (
            <>
              <Link to="/signin" className="signin-nav-link">{t('nav.signIn')}</Link>
              <Link to="/signup" className="signup-link">{t('nav.signUp')}</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
